export const dynamicResource = (req) => {
  const host = process.env.REACT_APP_RESOURCE_SUFFIX;
  const keys = req.keys();
  if (keys.length === 0) {
    throw new Error("Could not match resources for request", req);
  }
  const key = keys.find((key) => key.includes(`.${host}.`)) ?? keys[0];
  return req(key).default;
};
